import { cn } from "../../../lib/utils.js";

export interface ChartTooltipRow {
  name: string;
  value: string;
  /** Tailwind class setting the swatch background, e.g. `swatchClass(i)`. */
  swatchClass?: string;
}

/**
 * The hover card every Recharts primitive here renders. Kept as one component so
 * the tooltip reads the same on a donut, a bar and a share bar. Swatches wear the
 * palette's Tailwind classes -- only the SVG marks need resolved colour values.
 */
export function ChartTooltipCard({ title, rows, className }: { title?: string; rows: ChartTooltipRow[]; className?: string }) {
  return (
    <div className={cn(
      "pointer-events-none rounded-md border border-surface-200 bg-surface-0 px-2.5 py-2 shadow-[0_8px_24px_rgb(16_24_40_/_0.12)]",
      className,
    )}>
      {title && <div className="mb-1 text-[11px] font-semibold uppercase tracking-[0.5px] text-surface-500">{title}</div>}
      <ul className="flex flex-col gap-1">
        {rows.map(r => (
          <li key={r.name} className="flex items-center gap-2 text-[12px]">
            {r.swatchClass && <span className={cn("size-2 shrink-0 rounded-sm", r.swatchClass)} aria-hidden />}
            <span className="min-w-0 flex-1 truncate text-surface-700">{r.name}</span>
            <span className="shrink-0 font-semibold tabular-nums text-surface-900">{r.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
